import { IEntityContentJson } from '@mailupinc/bee-plugin/dist/types/bee'

import { BlogPostStatus, BlogPostType } from './types'

type Data<T> = T | undefined
type BeeData = {
  description: Data<string>
  descriptionTemplate: Data<IEntityContentJson>
}

interface IEditableField {
  key: string | string[]
  validateFn: (values: any) => boolean
}
type FormikEditableFieldReq = {
  [_: string]: IEditableField
}

const valueFilled = <T>(value: T) => !!value
const EditablePostFields: FormikEditableFieldReq = {
  title: { key: 'title', validateFn: (title) => valueFilled(title) },
  type: { key: 'type', validateFn: (type) => valueFilled(type) },
  image: { key: 'image', validateFn: (image) => valueFilled(image) },
  externalUrl: {
    key: 'externalUrl',
    validateFn: (externalUrl) => valueFilled(externalUrl),
  },
  publishedDate: {
    key: 'publishedDate',
    validateFn: (publishedDate) => valueFilled(publishedDate),
  },
  description: {
    key: ['description', 'descriptionTemplate'],
    validateFn: (beeData: BeeData) =>
      valueFilled(beeData?.description) &&
      valueFilled(beeData.descriptionTemplate),
  },
}

const { title, image, externalUrl, publishedDate, description, type } =
  EditablePostFields

export const requiredBlogPostFields = {
  [BlogPostStatus.DRAFT]: [title],
  [BlogPostStatus.PUBLISHED]: [title, type, image, publishedDate, description],
}

export const requiredPressPostFields = {
  [BlogPostStatus.DRAFT]: [title],
  [BlogPostStatus.PUBLISHED]: [title, image, externalUrl, publishedDate],
}

export const extractRequiredFieldCompletenessResults = ({
  formikValues,
  fieldSet,
}: {
  formikValues: any
  fieldSet: IEditableField[]
}) => {
  const filledBooleanArray = fieldSet.map((field) => {
    const keyset = field.key

    let valuesToValidate
    if (Array.isArray(keyset)) {
      valuesToValidate = Object.fromEntries(
        keyset.map((key) => [key, formikValues[key]])
      )
    } else {
      valuesToValidate = formikValues[keyset]
    }

    return field.validateFn(valuesToValidate)
  })

  return filledBooleanArray
}

export const getBlogPostTypeDisplayString = (blogPostType: string) => {
  const POST_TYPE_LOOKUP = {
    [BlogPostType.IT_CUSTOMER]: 'Tech Customer',
    [BlogPostType.TECH_VENDOR]: 'Tech Vendor',
  }

  return POST_TYPE_LOOKUP[blogPostType as BlogPostType]
}
